// AddBuilding.jsx
import { useState, useEffect, useCallback } from "react";
import debounce from "lodash/debounce";
import { Form, useOutletContext, redirect } from "react-router-dom";
import {
  FormRow,
  FormRowSelect,
  SubmitBtn,
  AutoCompleteInput,
  ImageCarousel,
} from "../components/index.js";
import Wrapper from "../assets/wrappers/DashboardFormPage.js";
import {
  RSS_NEWS,
  CITIES,
  WORK_ON_SATURDAY,
  MEMBER_TYPE,
  DID_YOU_KNOW,
} from "../../../utils/constants.js";
import { toast } from "react-toastify";
import { customFetch } from "../utils/custom-fetch.js";
import ManagerFormModal from "../components/Building/ManagerFormModal";

// export const action = async ({ request }) => {
//   const formData = await request.formData();
//   const data = Object.fromEntries(formData);
  
//   try {
//     if (data.numberOfFloors === 0 || data.numberOfFloors === "בחר מספר קומות") {
//       toast.error("חובה לבחור מספר קומות בבניין");
//       return null;
//     }
//     await customFetch.post("/buildings", data);
//     toast.success("הבניין נוצר בהצלחה");
//     return redirect("/dashboard/all-buildings");
//   } catch (error) {
//     toast.error(error?.response?.data?.msg);
//     return error;
//   }
// };

export const action = async ({ request }) => {
  const formData = await request.formData();
  const data = Object.fromEntries(formData);

  try {
    if (data.numberOfFloors === 0 || data.numberOfFloors === "בחר מספר קומות") {
      toast.error("חובה לבחור מספר קומות בבניין");
      return null;
    }

    if (data.buildingType === "משרדים") {
      // redirect to floors-navigation with form data (change logic as needed)
      const building = await customFetch.post("/floors-navigation", data);
      const newFloor = building.data.newFloor;
      
      toast.success("הבניין נוצר בהצלחה, יש להגדיר את הקומות");
      return redirect("/dashboard/add-floor/" + newFloor._id);
    } else {
      await customFetch.post("/buildings", data);
      toast.success("הבניין נוצר בהצלחה");
      return redirect("/dashboard/all-buildings");
    }
  } catch (error) {
    toast.error(error?.response?.data?.msg);
    return error;
  }
};


const AddBuilding = () => {
  const { user } = useOutletContext();
  const [formData, setFormData] = useState({
    city: "",
    // city: user.city || "",
    street: "",
    houseNumber: "",
    manager: "",
    maintenanceCompany: "",
    rssWeatherPath: "",
    rssTitleNewsPath: "מבזקים",
    nickname: "",
    rssNewsPath: "",
    workOnSaturday: WORK_ON_SATURDAY.NO,
    memberType: MEMBER_TYPE.FREE,
    buildingType: "מגורים",
    designTemplate: "default",
    didYouKnow: "יהדות ומסורת",
    numberOfFloors: 0,
    createdBy: user._id,
  });
  const [buildingType, setBuildingType] = useState("מגורים");
  const [streets, setStreets] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("default");
  const [showModal, setShowModal] = useState(false);

  const [streetSearch, setStreetSearch] = useState("");
  const [isLoadingStreets, setIsLoadingStreets] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const debouncedFetchStreets = useCallback(
    debounce(async (cityName, street = "", pageNum = 1) => {
      if (!cityName) return;

      if (cityName === "יפו" || cityName === "תל אביב")
        cityName = "תל אביב - יפו";

      try {
        setIsLoadingStreets(true);
        const response = await customFetch.get(
          `/buildings/streets/${encodeURIComponent(cityName)}`,
          {
            params: {
              search: street,
              page: pageNum,
              limit: 100,
            },
          }
        );

        const newStreets = response.data.streets;
        setStreets((prev) =>
          pageNum === 1 ? newStreets : [...prev, ...newStreets]
        );
        setHasMore(response.data.hasMore);
      } catch (error) {
        toast.error(error.response?.data?.message || "שגיאה בטעינת רחובות");
      } finally {
        setIsLoadingStreets(false);
      }
    }, 500),
    []
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSaveManager = () => {
    // כאן אתה יכול להוסיף קוד שמבצע פעולות לפני סגירת המודל
    setShowModal(false);
  };

  const handleCityChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      city: value,
      street: "",
    }));
    setStreets([]);
    setPage(1);
    setStreetSearch("");
  };

  // פונקציה חדשה לטיפול בבחירת עיר
  const handleCitySelect = (selectedOption) => {
    const cityValue = selectedOption ? selectedOption.value : "";
    setFormData((prev) => ({
      ...prev,
      city: cityValue,
      street: "",
    }));
    setStreets([]);
    setPage(1);
    setStreetSearch("");

    if (cityValue) {
      debouncedFetchStreets(cityValue, "", 1);
    }
  };

  const handleStreetSearch = (value) => {
    setStreetSearch(value);
    setStreets([]);
    setPage(1);
    if (formData.city) {
      debouncedFetchStreets(formData.city, value, 1);
    }
  };

  // const loadMoreStreets = () => {
  //   if (!isLoadingStreets && hasMore) {
  //     const nextPage = page + 1;
  //     setPage(nextPage);
  //     debouncedFetchStreets(formData.city, streetSearch, nextPage);
  //   }
  // };

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setFormData((prevFormData) => ({
      ...prevFormData,
      designTemplate: template,
    }));
  };

  const handleSelectBuildingType = (type) => {
    setBuildingType(type);
    setFormData((prevFormData) => ({
      ...prevFormData,
      buildingType: type,
    }));
  };

  const setMaintenanceCompanyId = (companyId) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      maintenanceCompany: companyId, // עדכון שדה חברת האחזקה
    }));
  };
  return (
    <Wrapper className="full-page">
      <Form method="post" className="form">
        <h4 className="form-title">הוספת בניין</h4>

        <div className="building-type-selection">
          <div className="building-type-cards">
            <div
              className={`building-type-card ${
                buildingType === "מגורים" ? "selected" : ""
              }`}
              onClick={() => handleSelectBuildingType("מגורים")}
            >
              <h6>בניין מגורים</h6>
            </div>
            <div
              className={`building-type-card ${
                buildingType === "משרדים" ? "selected" : ""
              }`}
              onClick={() => handleSelectBuildingType("משרדים")}
            >
              <h6>בניין משרדים</h6>
            </div>

            <div
              className={`building-type-card ${
                buildingType === "פרסום" ? "selected" : ""
              }`}
              onClick={() => handleSelectBuildingType("פרסום")}
            >
              <h6>פרסום</h6>
            </div>
          </div>
        </div>
        <input
          type="hidden"
          name="buildingType"
          value={formData.buildingType}
        />

        <div className="form-center" style={{ marginTop: "20px" }}>
          <AutoCompleteInput
            options={CITIES}
            name="city"
            labelText="עיר"
            placeholder="אנא בחר עיר מגורים..."
            value={formData.city}
            onChange={(e) => handleCityChange(e.target.value)}
            onSelect={handleCitySelect}
          />
          <input type="hidden" name="city" value={formData.city} />{" "}
          <AutoCompleteInput
            options={streets}
            name="street"
            labelText="רחוב"
            placeholder="אנא בחר רחוב..."
            value={formData.street}
            onChange={(e) => {
              console.log("Street change:", e.target.value);
              handleChange(e);
              handleStreetSearch(e.target.value);
            }}
            // onScroll={(e) => {
            //   const element = e.target;
            //   console.log(`Scrolling...`);
            //   if (
            //     element.scrollHeight - element.scrollTop <=
            //       element.clientHeight * 1.2 &&
            //     !isLoadingStreets &&
            //     hasMore
            //   ) {
            //     const nextPage = page + 1;
            //     setPage(nextPage);
            //     debouncedFetchStreets(formData.city, streetSearch, nextPage);
            //   }
            // }}
            isLoading={isLoadingStreets}
          />
          <input type="hidden" name="street" value={formData.street} />
          <FormRow
            type="number"
            name="houseNumber"
            labelText="מספר בית"
            value={formData.houseNumber}
            handleChange={handleChange}
            isRequired={true}
          />
          <FormRow
            type="text"
            name="nickname"
            labelText="שם לבניין (לא חובה יופיע במקום הכתובת אם נבחר)"
            value={formData.houseNumber}
            handleChange={handleChange}
            placeholder="לדוגמא: בריאותא , או שם העסק"
            isRequired={false}
          />
          <FormRowSelect
            labelText="מספר קומות בבניין (חובה) "
            type="number"
            name="numberOfFloors"
            isRequired={true}
            list={[
              "בחר מספר קומות",
              ...Array.from({ length: 51 }, (_, i) => i + 1),
            ]}
            value={formData.numberOfFloors}
            defaultValue={formData.numberOfFloors}
            handleChange={handleChange}
          />
          <FormRowSelect
            labelText="תחומי החדשות שיופיעו בכתוביות"
            name="rssTitleNewsPath"
            list={Object.values(RSS_NEWS)}
            value={formData.rssTitleNewsPath}
            handleChange={handleChange}
          />
          <FormRowSelect
            labelText="הידעת בחירת נושא"
            name="didYouKnow"
            list={Object.values(DID_YOU_KNOW)}
            value={formData.didYouKnow}
            handleChange={handleChange}
          />
          <FormRowSelect
            labelText="פעילות בשבת"
            name="workOnSaturday"
            list={Object.values(WORK_ON_SATURDAY)}
            value={formData.workOnSaturday}
            handleChange={handleChange}
          />
          <button
            type="button"
            className="btn btn-block"
            onClick={() => setShowModal(true)}
          >
            קישור לחברת אחזקה
          </button>
        </div>

        <div
          className="form-center"
          style={{
            marginTop: "20px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h3
            htmlFor="carousel"
            style={{
              textAlign: "center",
              width: "100%",
              marginBottom: "1rem",
            }}
          >
            יש לבחור תבנית עיצוב
          </h3>
          <ImageCarousel
            name="carousel"
            onTemplateSelect={handleTemplateSelect}
            selectedTemplate={selectedTemplate}
          />
        </div>

        {formData.maintenanceCompany && (
          <input
            type="hidden"
            name="maintenanceCompany"
            value={formData.maintenanceCompany}
          />
        )}
        <input type="hidden" name="designTemplate" value={selectedTemplate} />
        {/* <input type="hidden" name="manager" value={formData.manager || ""} /> */}

        <div className="btn-container">
          <SubmitBtn formBtn buttonText="שמירה" />
          <button
            className="btn btn-block clear-btn"
            onClick={(e) => {
              e.preventDefault();
              setFormData(initialState);
            }}
          >
            ניקוי שדות
          </button>
        </div>
      </Form>

      {showModal && user.role === "user" && (
        <ManagerFormModal
          setMaintenanceCompanyId={setMaintenanceCompanyId}
          closeModal={() => setShowModal(false)}
          handleSave={handleSaveManager}
        />
      )}

      <style>
        {`
.building-type-cards {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.building-type-card {
  width: 48%;
  padding: 20px;
  border: 1px solid var(--grey-500);
  border-radius: var(--borderRadius);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

.building-type-card.selected {
  background-color: var(--primary-500);
  color: white;
}

.template-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
  align-items: center;
  justify-content: center;
  max-width: 100%;
}

.template-card {
  flex-basis: 30%;
  
  margin: 10px;
  opacity: 0.7;
  border-radius: var(--borderRadius);
  cursor: pointer;
  text-align: center;
  justify-content: space-between;
  transition: all 0.3s ease;
  border: 1px solid var(--grey-500);
}

.template-card.selected {
  border: 3px solid var(--primary-500);
  opacity: 1;
}

.template-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  margin-bottom: 1.5rem;
}

.plan-cards {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.plan-card {
  width: 48%;
  padding: 20px;
  border: 1px solid var(--grey-500);
  border-radius: var(--borderRadius);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

.plan-card.selected {
  background-color: var(--primary-500);
  color: white;
}

.plan-card h6 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.plan-card p {
  font-size: 1rem;
}

/* רספונסיביות */
@media (max-width: 768px) {
  .template-card {
    flex-basis: 100%;
    margin-top: 1rem;
  }

  .plan-card {
    margin-bottom: 1rem;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .template-card {
    flex-basis: 48%;
    margin: 20px;
  }
}

@media (min-width: 800px) {
  .template-gallery {
    width: 56.25vw;
    height: 31.64vw;
    align-items: center;
  }
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    max-width: 500px;
    width: 100%;
  }

  .modal-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
`}
      </style>
    </Wrapper>
  );
};

export default AddBuilding;
